import { escapeRegExp } from 'lodash';
import React from 'react';

interface HighlightedTextProps {
  text: string;
  textClassName: string;
  highlight: string;
}

import styles from './HighlightedText.module.scss';

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  textClassName,
  highlight,
}) => {
  if (!highlight.trim()) {
    return <span className={textClassName}>{text}</span>;
  }
  const regex = new RegExp(
    `(${escapeRegExp(highlight.trim())})`.trim().replace(/\ /g, '|'),
    'gi',
  );
  const parts = text.split(regex);
  return (
    <span className={textClassName}>
      {parts
        .filter((part) => part)
        .map((part, i) =>
          regex.test(part) ? (
            <span className={styles.searchText} key={i}>
              {part}
            </span>
          ) : (
            <span key={i}>{part}</span>
          ),
        )}
    </span>
  );
};
